var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"hight-light"},[_c('div',{staticClass:"content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBg),expression:"isBg"}]},[_c('strong',[_vm._v(_vm._s(_vm.bgText))])]),_c('p',[_vm._v(_vm._s(_vm.text))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }